<template>
    <div class="practitioner-list">

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :show-details="false"
                    :get-items="getPractitioners"
                    :filters="filters"
                    :fields="fields">

            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key == 'actions'">
                    <router-link class="btn btn-secondary btn-sm mr-2"
                                 :to="getUpdateRoute(slotProps.row.item)">
                        <shs-icon name="pencil"></shs-icon>
                    </router-link>
                    <b-btn size="sm"
                           variant="danger"
                           @click="deletePractitioner(slotProps.row.item)">
                        <shs-icon name="delete"></shs-icon>
                    </b-btn>
                </div>
                <div v-else-if="slotProps.row.field.key == 'role'">
                    {{ slotProps.row.item.role }}
                    <b-badge variant="danger" class="ml-3"
                             v-if="slotProps.row.item.disabled">
                        {{ $i18n.gt('LABEL_DISABLED') }}
                    </b-badge>
                </div>
                <div v-else-if="slotProps.row.field.key == 'lastActiveTime'">
                    <timestamp :date="slotProps.row.item.participant.lastActiveTime"></timestamp>
                </div>
                <div v-else-if="slotProps.row.field.key == 'receive_appointment_alert'">
                    {{ slotProps.row.item.receive_appointment_alert ? 'Yes' : '' }}
                </div>
            </template>

            <!-- TODO: implement question stats -->
<!--            <template v-slot:customRowDetails="slotProps">-->
<!--                <div class="float-right ml-3">-->
<!--                    <router-link class="btn btn-primary ml-3"-->
<!--                                 :to="`/practitioner/aggregateReport/id/${slotProps.row.item.id}`">-->
<!--                        {{ $i18n.gt('LABEL_QUESTION_STATISTICS') }}-->
<!--                    </router-link>-->
<!--                </div>-->
<!--            </template>-->

        </data-table>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Table listing Practitioners for a Practice
 */
export default Vue.extend({
    name: 'practitioner-list',
    props: {
        practiceId: Number
    },
    data() {
        const roleOptions = [
            {value: 'PHYSICIAN', text: 'Physician'},
            {value: 'MEDICAL_SPECIALIST', text: 'Medical Specialist'},
            {value: 'NURSE_PRACTITIONER', text: 'Nurse Practitioner'},
            {value: 'PHYSICIAN_ASSISTANT', text: 'Physician Assistant'},
            {value: 'NURSE_SPECIALIST', text: 'Nurse Specialist'},
            {value: 'NURSE', text: 'Nurse'},
            {value: 'MEDICAL_ASSISTANT', text: 'Medical Assistant'},
            {value: 'PRACTICE_MANAGER', text: 'Practice Manager'},
            {value: 'WELLNESS_COACH', text: 'Wellness Coach'},
            {value: 'HEALTH_MENTOR', text: 'Health Mentor'},
            {value: 'DIETITIAN', text: 'Dietitian'},
            {value: 'EXERCISE_SPECIALIST', text: 'Exercise Specialist'},
        ]

        return {
            filters: {
                practice_id: {field: 'practice_id', type: 'hidden', value: this.practiceId},
                text: {field: 'text', type: 'string', value: null, label: 'First/Last Name'},
                role: {field: 'role', type: 'select', value: null, label: 'Role', options: roleOptions},
            },
            fields: [
                {
                    key: 'participant.firstname', sortable: true, label: 'First Name',
                    get: (item) => {
                        return item.participant.firstname
                    }
                },
                {
                    key: 'participant.lastname', sortable: true, label: 'Last Name',
                    get: (item) => {
                        return item.participant.lastname
                    }
                },
                {key: 'role', sortable: true, label: 'Role'},
                {key: 'lastActiveTime', sortable: true, label: 'Last Active'},
                {key: 'receive_appointment_alert', sortable: true, label: 'Appointment Alert?'},
                {key: 'actions', sortable: false},
            ],
        }
    },
    methods: {
        getPractitioners(listParams) {
            return this.$api.getPractitioners(this, this.filters, listParams)
        },
        getUpdateRoute(practitioner) {
            if (this.$user.roleIsAdmin()) {
                return `/practitioner/update/companyId/${practitioner.practice.company_id}/practiceId/${practitioner.practice.id}/id/${practitioner.id}`
            } else {
                return `/practice/practitionerUpdate/id/${practitioner.id}`
            }
        },
        async deletePractitioner(practitioner) {
            const msg = `Delete practitioner ${practitioner.participant.firstname} ${practitioner.participant.lastname} permanently from the database?`
            if (await this.$bvModal.msgBoxConfirm(msg)) {
                try {
                    await this.$api.deleteItem(this, 'practitioner', practitioner)
                    this.$toasted.show('Practitioner deleted', {duration: 3000})
                    this.$refs.dataTable.refresh();
                } catch (e) {
                    this.$utils.handleError(e, 'Error deleting practitioner')
                }
            }
        },
    },
})

</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
#filter-radios {
    .custom-radio {
        display: block;
    }
}
</style>
